import { render, staticRenderFns } from "./module-info.vue?vue&type=template&id=c545c266&scoped=true"
import script from "./module-info.vue?vue&type=script&lang=js"
export * from "./module-info.vue?vue&type=script&lang=js"
import style0 from "./module-info.vue?vue&type=style&index=0&id=c545c266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c545c266",
  null
  
)

export default component.exports